import { nextRecipeTextSize, parseRecipeTextSize, RECIPE_TEXT_SIZE_KEY } from '@platewell/core';
import { useState } from 'react';

/**
 * The recipe text size, remembered on this device so someone who needs larger text does not
 * have to ask for it on every recipe.
 */
export function useRecipeTextSize(): [index: number, increase: () => void] {
  const [index, setIndex] = useState(() => {
    try {
      return parseRecipeTextSize(window.localStorage.getItem(RECIPE_TEXT_SIZE_KEY));
    } catch {
      return 0;
    }
  });

  function increase() {
    const next = nextRecipeTextSize(index);
    setIndex(next);
    try {
      window.localStorage.setItem(RECIPE_TEXT_SIZE_KEY, String(next));
    } catch {
      // Private browsing can refuse storage; the size still applies until the page closes.
    }
  }

  return [index, increase];
}
